import { render, staticRenderFns } from "./Bmap.vue?vue&type=template&id=0afbae44&scoped=true"
import script from "./Bmap.vue?vue&type=script&lang=js"
export * from "./Bmap.vue?vue&type=script&lang=js"
import style0 from "./Bmap.vue?vue&type=style&index=0&id=0afbae44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afbae44",
  null
  
)

export default component.exports